module.exports = __webpack_public_path__ + "img/Kosovo.304c1b81.png";